import React from 'react';
import { tns } from 'tiny-slider/src/tiny-slider';
import { SitecoreImageField } from 'components/sitecore-fields';

class OfferListCarousel extends React.Component {
    constructor(props) {
        super(props);

        this.gallery = null;
        this.slides = React.createRef();
    }

    componentDidMount() {
        if (this.props.hasCarousel) {
            this.gallery = tns({
                container: this.slides.current,
                loop: false,
                nav: false,
                items: 1,
                gutter: 20,
                controls: false
            });
            this.props.getNode(this.gallery);
        }
    }

    componentWillUnmount() {
        if (this.gallery !== null) {
            this.gallery.destroy();
        }
    }

    render() {
        const { offers, defaultImage } = this.props;

        return (
            <div className="offer-list__carousel--slides" ref={this.slides}>
                {
                    offers.map((offer, index) => {
                        return (
                            <>
                                {
                                    offer.link &&
                                    < div key={index} className='offer-list__carousel--card-wrapper' >
                                        <div className='offer-list__carousel-card'>
                                            {
                                                offer.image !== undefined && offer.image !== "" &&
                                                <div className='offer-list__carousel-card--bg'>
                                                    <SitecoreImageField img={offer.image} className='offer-list__carousel-card--image' />
                                                </div>
                                            }
                                            {
                                                (offer.image === undefined || offer.image === "") &&
                                                <div className='offer-list__carousel-card--bg'>
                                                    <SitecoreImageField img={defaultImage} className='offer-list__carousel-card--image' />
                                                </div>
                                            }
                                            <div className='offer-list__carousel-card--content-wrapper'>
                                                <div className='offer-list__carousel-card--title'>
                                                    {offer.description}
                                                </div>

                                                {
                                                    (offer.link.url !== null || offer.link.url !== undefined) &&
                                                    <a className="offer-list__carousel-card--cta button button--primary" href={offer.link.url}>
                                                        {offer.textLink}
                                                    </a>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>
                        );
                    })
                }
            </div >
        );
    }
}

export default OfferListCarousel;
